'use client';

import * as React from 'react';

import {
  isBefore,
  isAfter,
  format,
  formatDistanceToNow,
} from 'date-fns';

import useInterval from '@/hooks/use-interval';

interface Props {
  date: string | Date;
  secretDate?: string | Date;
}

export default function TimeRemaining({
  date: dateString,
  secretDate: secretDateString,
}: Props) {
  const [now, setNow] = React.useState(new Date());

  useInterval(() => {
    setNow(new Date());

    // Update twice a minute.
    // I can make this a prop if it needs to vary from one use case to another.
  }, 1000 * 30);

  const date: Date = new Date(dateString);
  const secretDate: Date | null = secretDateString
    ? new Date(secretDateString)
    : null;

  const isInTwilightWindow =
    secretDate && isBefore(now, secretDate) && isAfter(now, date);

  let relevantDate = isInTwilightWindow ? secretDate : date;

  // If the date is in the past, we don't want to show a negative time. Instead, render the date (eg. "January 15th")
  if (isAfter(now, relevantDate)) {
    return (
      <time
        dateTime={relevantDate.toISOString()}
        title={format(relevantDate, "MMM do 'at' h:mm a")}
      >
        on {format(relevantDate, 'MMMM do')}
      </time>
    );
  }

  let formattedTime = `in ${formatDistanceToNow(relevantDate)}`;

  if (formattedTime === 'in 1 day') {
    formattedTime = 'tomorrow';
  }

  return (
    <time
      dateTime={relevantDate.toISOString()}
      title={format(relevantDate, "MMM do 'at' h:mm a")}
    >
      {formattedTime}
    </time>
  );
}
